export const PROFILE = {
  name: "Catherine Magawa",
  first: "Catherine",
  last: "Magawa",
  role: "Epidemiologist & Biostatistician",
  tagline:
    "Reading the signal inside public health data — from outbreak curves to survey rows — and turning it into evidence people can act on.",
  location: "Nairobi, Kenya",
  email: "cath.magawa@gmail.com",
  phone: "+254 706 037 437",
  portrait:
    "https://customer-assets-v7afamib.emergentagent.net/job_epi-portfolio/artifacts/570moo2b_mdada.png",
  logo: "/catherine-logo.png",
  research_bg:
    "https://customer-assets-v7afamib.emergentagent.net/job_epi-portfolio/artifacts/688en88a_pexels-towfiqu-barbhuiya-loyalt-free.webp",
  // Original research_bg (kept in case we need to revert):
  // research_bg:
  //   "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxlcGlkZW1pb2xvZ3klMjBkYXRhJTIwY2hhcnRzJTIwbmV0d29ya3xlbnwwfHx8fDE3ODUwNTMxNTR8MA&ixlib=rb-4.1.0&q=85",
  // Earlier uploaded pills/face image (also kept as an option):
  // research_bg:
  //   "https://customer-assets-v7afamib.emergentagent.net/job_epi-portfolio/artifacts/o3874k95_pexels-cottonbro-loyalt-free.webp",
};

export const ABOUT = [
  "I'm an Epidemiology & Biostatistics graduate from United States International University – Africa, having completed my degree in 2026. My work sits at the intersection of fieldwork and data: I've helped run disease surveillance systems, cleaned and analysed survey data for national statistics, and led a university research project from proposal to final report.",
  "I'm trained in Event-Based Surveillance and Integrated Disease Surveillance and Response, and comfortable in R for statistical analysis. What I care most about is the translation step — taking a dataset or a surveillance signal and making it legible enough that the right person can act on it in time.",
  "Now that I've graduated, I'm looking for my first full-time role in epidemiology, biostatistics, or public health data — anywhere in the world.",
];

export const STATS = [
  { label: "Graduated", value: "2026" },
  { label: "Degree", value: "Epidemiology & Biostatistics" },
  { label: "Institution", value: "USIU-Africa" },
  { label: "Internships completed", value: "3" },
  { label: "Certifications", value: "EBS · IDSR" },
  { label: "Core tools", value: "R · MS EXCEL" },
  { label: "Based in", value: "Nairobi, Kenya" },
  { label: "Open to", value: "Roles worldwide" },
];

export const COUNTERS = [
  { num: 3, suffix: "", label: "Internships across MOH, KNBS & KUTRRH" },
  { num: 2, suffix: "", label: "Surveillance certifications — EBS & IDSR" },
  { num: 1, suffix: "", label: "End-to-end research project led in R" },
];

export const EXPERIENCE = [
  {
    date: "2026 — Present",
    role: "Research Collaborator, Infectious Disease Research",
    org: "Kenyatta University Teaching, Referral and Research Hospital (KUTRRH)",
    desc: "Contributing to a multidisciplinary research team generating evidence for disease prevention, surveillance, and public health decision-making.",
  },
  {
    date: "09/2025 — 09/2026",
    role: "Public Relations Officer, Epidemiology & Biostatistics",
    org: "USIU-Africa",
    desc: "Communicated public health data to diverse audiences, translating technical findings into clear, simple messages and supporting awareness campaigns with data insights.",
  },
  {
    date: "2026 · 1 month",
    role: "Public Health Intern, Disease Surveillance",
    org: "Kenyatta University Teaching, Referral and Research Hospital (KUTRRH)",
    desc: "Took part in disease surveillance, epidemiological investigations, data management, and public health reporting.",
  },
  {
    date: "2026 · 1 month",
    role: "Statistics Intern",
    org: "Kenya National Bureau of Statistics (KNBS)",
    desc: "Gained experience in official statistics, survey methodology, census processes, data quality assurance, and production of national statistics for policy and planning.",
  },
  {
    date: "2026 · 1 month",
    role: "Public Health Intern, Surveillance & Disease Control",
    org: "Ministry of Health (MOH), Kenya",
    desc: "Supported public health surveillance, disease monitoring, health information management, and disease prevention and control programmes.",
  },
];

export const RESEARCH = {
  title:
    "Prevalence and Determinants of Self-Medication Practice Among Undergraduate Students at USIU-Africa, Kenya",
  desc: "Designed and led this undergraduate research project end-to-end: developing the study proposal, building the data collection tools, gathering and analysing data in R, interpreting the findings, and writing up the results as a scientific report. The study examined how and why students self-medicate — evidence that speaks directly to health-behaviour policy on campus.",
  tags: [
    "Study design",
    "Survey methodology",
    "R analysis",
    "Health behaviour",
    "Scientific writing",
  ],
};

export const EDUCATION = {
  school: "United States International University – Africa (USIU-Africa), Nairobi",
  degree: "Bachelor's Degree, Epidemiology & Biostatistics · 2022 – 2026 (Graduated)",
  tags: [
    "Regression modelling",
    "Research methods in health",
    "Monitoring & evaluation of health",
  ],
  pdf: "/certificates/usiu-degree-certificate.pdf",
};

export const CERTS = [
  {
    title: "Event-Based Surveillance (EBS)",
    desc: "Detecting, verifying, reporting, and responding to unusual public health events.",
    issuer: "MOH Virtual Academy · 2026",
    pdf: "/certificates/event-based-surveillance.pdf",
  },
  {
    title: "Integrated Disease Surveillance and Response (IDSR)",
    desc: "Case detection, reporting procedures, data analysis, and outbreak investigation in line with national and international guidelines.",
    issuer: "WHO Regional Office for Africa · 2026",
    pdf: "/certificates/idsr-training.pdf",
  },
];

export const LEADERSHIP = [
  {
    title: "Team Manager, University Handball Team",
    org: "3 years",
    desc: "Organised schedules, training, and competition logistics; supported communication between players and coaches.",
    pdf: "/certificates/handball-team-certificate.pdf",
  },
  {
    title: "Public Relations Leader, EpiBio Club",
    org: "USIU-Africa",
    desc: "Promoted club activities, coordinated member communication, and helped run academic and professional events.",
  },
  {
    title: "Community Volunteer",
    org: "Nyumba Ya Wazee (Little Sisters of the Poor) · 3 months",
    desc: "Supported daily care of elderly residents; awarded a certificate for service and commitment to community welfare.",
    pdf: "/certificates/community-service.pdf",
  },
];

export const SKILLS = [
  {
    group: "Research & analysis",
    items: [
      "Study & survey design",
      "Statistical analysis in R & Microsoft Excel",
      "Data cleaning & management",
      "Scientific report writing",
    ],
  },
  {
    group: "Surveillance & systems",
    items: [
      "Disease surveillance (EBS, IDSR)",
      "Outbreak investigation",
      "Official statistics & census methods",
      "Health information management",
    ],
  },
  {
    group: "Communication & leadership",
    items: [
      "Public health communication",
      "Team & project coordination",
      "Cross-functional collaboration",
      "Event & campaign support",
    ],
  },
];

export const FAQS = [
  {
    q: "What kind of roles is Catherine looking for?",
    a: "A first full-time role in epidemiology, biostatistics or public-health data — spanning disease surveillance, health-data analysis, monitoring & evaluation, and research support. She is open to opportunities anywhere in the world.",
  },
  {
    q: "When is Catherine available to start?",
    a: "She has graduated and is available to start work immediately.",
  },
  {
    q: "Where is she based, and is she open to relocation or remote work?",
    a: "She is based in Nairobi, Kenya, and is open to relocating internationally as well as to remote and hybrid arrangements.",
  },
  {
    q: "What are her core technical skills?",
    a: "Statistical analysis in R and Microsoft Excel, study and survey design, data cleaning and management, disease surveillance (EBS and IDSR), outbreak investigation, official statistics and census methods, and scientific report writing.",
  },
  {
    q: "What is her educational and professional background?",
    a: "She holds a Bachelor's degree in Epidemiology & Biostatistics from United States International University – Africa (2022–2026, graduated), with internships across the Ministry of Health, the Kenya National Bureau of Statistics, and Kenyatta University Teaching, Referral & Research Hospital.",
  },
  {
    q: "How can I get in touch or download her CV?",
    a: "Use the contact form in the “Get in touch” section below, email cath.magawa@gmail.com directly, or click “Download CV” in the navigation to get a one-page PDF.",
  },
];


export const WRITING = [
  {
    slug: "surveillance-signal-to-decision",
    tag: "Field note",
    title: "Turning a surveillance signal into a decision",
    excerpt:
      "A spike on a line list is only useful if someone acts on it. Working across EBS and IDSR, I learned that the hardest part of surveillance isn't detection — it's compressing a noisy signal into a single, verifiable sentence a decision-maker can move on within hours.",
    meta: "EBS · IDSR",
    date: "May 2025",
    readTime: "4 min read",
    body: [
      { type: "p", text: "The first time I watched a cluster of cases surface on a line list, I assumed the difficult work was over. We had detected something. In reality, detection was the easy part. The signal sat there — a handful of rows, a suspicious rise — waiting for someone to decide whether it meant anything." },
      { type: "h", text: "Detection is cheap, interpretation is expensive" },
      { type: "p", text: "Event-Based Surveillance trains you to cast a wide net: rumours, media reports, community alerts. Integrated Disease Surveillance and Response gives you the structure to verify and escalate them. But between the alert and the action lies a translation problem. A district health officer does not have time to read a dataset. They need one sentence: what is happening, how confident are we, and what should happen next." },
      { type: "p", text: "So I started writing that sentence before I wrote anything else. If I couldn't compress the signal into a single, verifiable claim, I didn't understand it well enough yet. That discipline changed how I cleaned data, how I framed tables, and how I flagged uncertainty — because every choice had to survive being reduced to a decision." },
      { type: "h", text: "What I carry forward" },
      { type: "p", text: "Surveillance is ultimately a communication system wearing a statistics costume. The maths matters, but the value is created in the last hundred metres — when a signal becomes a sentence, and a sentence becomes a response that reaches people in time." },
    ],
  },
  {
    slug: "self-medication-findings",
    tag: "Research",
    title: "What self-medication data revealed about student health",
    excerpt:
      "Designing the self-medication study end-to-end taught me that determinants rarely live in one variable. Cost, access and prior experience interacted in ways a single regression coefficient couldn't tell — so I let the analysis map behaviour, not just measure it.",
    meta: "R · Survey design",
    date: "March 2025",
    readTime: "5 min read",
    body: [
      { type: "p", text: "My undergraduate research asked a deceptively simple question: how and why do students at USIU-Africa self-medicate? I built the proposal, designed the instrument, collected the responses and ran the analysis in R. Owning the whole pipeline meant I couldn't hide behind any single step." },
      { type: "h", text: "Determinants don't live alone" },
      { type: "p", text: "I went in expecting a tidy set of predictors. What I found was interaction. Cost shaped behaviour differently depending on proximity to a pharmacy. Prior experience with a drug mattered more for some symptoms than others. A single regression coefficient could report an association, but it couldn't narrate the behaviour — and behaviour was the point." },
      { type: "p", text: "So I let the analysis map rather than merely measure. Cross-tabulations, stratified models and honest visualisations did more to explain self-medication than any one p-value. The goal shifted from proving an effect to describing a pattern a health-behaviour policy could actually respond to." },
      { type: "h", text: "Evidence that speaks to policy" },
      { type: "p", text: "The most useful finding wasn't a number — it was a story the numbers supported: students self-medicate when the formal system feels slow, costly or distant. That framing is something a campus health office can act on, and it is the version of the result I care most about." },
    ],
  },
  {
    slug: "cleaning-survey-data",
    tag: "Method",
    title: "Cleaning national survey data without losing the story",
    excerpt:
      "At KNBS I saw how quality assurance shapes every downstream statistic. A dropped decimal or a mis-coded response ripples into policy. Good data cleaning is less about tidiness and more about protecting the meaning inside each row.",
    meta: "Official statistics",
    date: "February 2025",
    readTime: "4 min read",
    body: [
      { type: "p", text: "During my internship at the Kenya National Bureau of Statistics I expected data cleaning to be mechanical — deduplicate, standardise, move on. Instead I learned it is one of the most consequential acts in the entire statistical chain." },
      { type: "h", text: "Every row is a person" },
      { type: "p", text: "A mis-coded response is not a formatting nuisance; it is a household misrepresented in a figure that will inform planning and budgets. A dropped decimal doesn't just fail a validation check — it can quietly distort a national estimate. Once you internalise that, quality assurance stops feeling like chores and starts feeling like stewardship." },
      { type: "p", text: "I began treating each cleaning decision as a small ethical one: am I removing noise, or am I erasing signal? Documenting why a value was changed became as important as the change itself, because reproducibility is how you protect meaning when your work outlives your memory of it." },
      { type: "h", text: "Tidiness in service of truth" },
      { type: "p", text: "Clean data should be tidy, yes — but tidiness is the means, not the end. The end is a dataset where every row still tells the truth it was collected to tell." },
    ],
  },
];
